<template>
  <div class="nationality-list">
    <div v-for="(column, columnIndex) in columns" :key="columnIndex" class="nationality-list__column">
      <nationality-list-item
        v-for="nationality in column"
        :key="nationality.name"
        :nationality="nationality"
        :highlighted="highlighted === nationality.name"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import NationalityListItem from './NationalityListItem.vue'

export default {
  name: 'NationalityList',
  components: { NationalityListItem },
  props: {
    // [{ name, count, percent, color, hoverColor }], listed top to bottom, left column first
    nationalities: {
      type: Array,
      default: () => [],
    },
    // Name of the nationality to draw in its hover color. Item hover events reach the parent through $listeners
    highlighted: {
      type: String,
      default: null,
    },
  },
  computed: {
    columns() {
      const half = Math.ceil(this.nationalities.length / 2)
      return [this.nationalities.slice(0, half), this.nationalities.slice(half)].filter(column => column.length > 0)
    },
  },
}
</script>

<style scoped>
.nationality-list {
  display: flex;
  gap: 32px;
}

.nationality-list__column {
  flex: 1;
  min-width: 0;
}

@media (max-width: 991px) {
  .nationality-list {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
